import { ActivatedRoute } from '@angular/router';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-copywrite',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './copywrite.component.html',
  styleUrls: ['./copywrite.component.scss']
})

export class CopywriteComponent implements OnInit, OnChanges {
  showflag:boolean=false;
  @Input() widgetDesc: string;
  @Input() inputData: any;
  @Input() page: any;
  @Input() suggestion: any;
  headerTitle: string = '';
  constructor( private a_route: ActivatedRoute) { }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle widgetDesc changes for NgComponentOutlet compatibility
    if (changes.widgetDesc && changes.widgetDesc.currentValue) {
      this.headerTitle = changes.widgetDesc.currentValue;
    }
  }

  ngOnInit() {
    //I commented the set timeout  that makes an unwanted time to show. 
    this.showflag=true;
    // setTimeout(() => {
    // }, 4000);

    // Only set headerTitle if widgetDesc is provided (ngOnChanges handles dynamic updates)
    if (this.widgetDesc) {
      this.headerTitle = this.widgetDesc;
    }
    this.a_route.queryParams.subscribe((res) => {
        if(res.master!="NETWORK" && res.master!="TEAM" && res.menu!=null &&res.menu!=undefined){
          this.headerTitle=res.menu;
       }
    })
  }
}
